<template>
  <div class="w-full h-full overflow-scroll">
    <nav class="flex flex-1 flex-col">
      <tree-view class="my-4 mr-4" :items="items" @click="onClick" @plan-click="onPlanClick" />
    </nav>
  </div>
</template>

<script setup>
import TreeView from './TreeView.vue';
import { items, getItems } from '../store/PanelList';

const emit = defineEmits([ 'click', 'plan-click' ]);

getItems();

function onClick(item) {
  // if (item.levelId === undefined) {
  //   // levels can't be selected in viewer
  //   return;
  // }

  emit('click', item);
}

function onPlanClick(item) {
  emit('plan-click', item);
}
</script>
